import type { FC } from 'react';
import React from 'react';

import { EN_DASH } from 'Utilities/consts';

import styles from './NavigationHeader.module.scss';

export type NavigationHeaderProps = {
	category: string;
	slug?: string;
};

const NavigationHeader: FC<NavigationHeaderProps> = ({ category, slug }) => (
	<div className={styles.container}>
		<section>
			<span className={styles.categoryText}>{category}</span>
			{slug && <span className={styles.slugText}>{` ${EN_DASH} ${slug}`}</span>}
		</section>
	</div>
);

export default NavigationHeader;
